import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { css } from 'styled-components';
function mediaQueries(breakPoints) {
  return Object.keys(breakPoints).reduce((acc, label) => {
    acc[label] = function () {
      return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      @media (min-width: ", "em) {\n        ", ";\n      }\n    "])), breakPoints[label], css(...arguments));
    };
    return acc;
  }, {});
}
export { mediaQueries as default };